$(document).on('click', '.js-see-all', function(e) {
  // Do not propagate click when user has clicked on nested element AND this nested element is a link.
  // E.g. we have DOM like:
  // div1
  //   h1 title
  //   a1 link one
  //   a2 link two
  // and we attach click event to div1 we would like to have whole div1 clickable,
  // including h1 tag, but a1,a2 links should not be binded to `click` event
  // since they are links redirecting to another resources.
  if(e.target != this && e.target.tagName.toLowerCase() === 'a') return;
  e.preventDefault();
  var $elem = $(this);
  $elem.parents('.js-see-all-container').find('.js-see-all-hidden').removeClass('hidden');
  $elem.addClass('hidden');
});
